import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { cachedSerialNames31jc5fovi62px as cachedSerialNames } from './Platform.common.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from '../descriptors/SerialDescriptor.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from './CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var NullableSerializerClass;
function NullableSerializer() {
  if (NullableSerializerClass === VOID) {
    class $ {
      constructor(serializer) {
        this.serializer_1 = serializer;
        this.descriptor_1 = new (SerialDescriptorForNullable())(this.serializer_1.get_descriptor_wjt6a0_k$());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_k0t1hm_k$(encoder, value) {
        if (!(value == null)) {
          encoder.encodeNotNullMark_415a1t_k$();
          encoder.encodeSerializableValue_3uuzip_k$(this.serializer_1, value);
        } else {
          encoder.encodeNull_ejiosz_k$();
        }
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_k0t1hm_k$(encoder, value);
      }
      deserialize_sy6x50_k$(decoder) {
        return decoder.decodeNotNullMark_us4ba1_k$() ? decoder.decodeSerializableValue_xpnpad_k$(this.serializer_1) : decoder.decodeNull_jzrmuj_k$();
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof NullableSerializer()))
          THROW_CCE();
        if (!equals(this.serializer_1, other.serializer_1))
          return false;
        return true;
      }
      hashCode() {
        return hashCode(this.serializer_1);
      }
    }
    initMetadataForClass($, 'NullableSerializer', VOID, VOID, [KSerializer()]);
    NullableSerializerClass = $;
  }
  return NullableSerializerClass;
}
var SerialDescriptorForNullableClass;
function SerialDescriptorForNullable() {
  if (SerialDescriptorForNullableClass === VOID) {
    class $ {
      constructor(original) {
        this.original_1 = original;
        this.serialName_1 = this.original_1.get_serialName_u2rqhk_k$() + '?';
        this.serialNames_1 = cachedSerialNames(this.original_1);
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_serialNames_8zf3cl_k$() {
        return this.serialNames_1;
      }
      get_isNullable_67sy7o_k$() {
        return true;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerialDescriptorForNullable()))
          return false;
        if (!equals(this.original_1, other.original_1))
          return false;
        return true;
      }
      toString() {
        return toString(this.original_1) + '?';
      }
      hashCode() {
        return imul(hashCode(this.original_1), 31);
      }
      get_kind_wop7ml_k$() {
        return this.original_1.get_kind_wop7ml_k$();
      }
      get_isInline_usk17w_k$() {
        return this.original_1.get_isInline_usk17w_k$();
      }
      get_elementsCount_288r0x_k$() {
        return this.original_1.get_elementsCount_288r0x_k$();
      }
      get_annotations_20dirp_k$() {
        return this.original_1.get_annotations_20dirp_k$();
      }
      getElementName_u4sqmf_k$(index) {
        return this.original_1.getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return this.original_1.getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return this.original_1.getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return this.original_1.getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return this.original_1.isElementOptional_heqq56_k$(index);
      }
    }
    initMetadataForClass($, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorForNullableClass = $;
  }
  return SerialDescriptorForNullableClass;
}
//region block: exports
export {
  NullableSerializer as NullableSerializer41etqlj0tdq5,
  SerialDescriptorForNullable as SerialDescriptorForNullable2slcv65za9oog,
};
//endregion

//# sourceMappingURL=NullableSerializer.mjs.map
